import React from 'react';
import { ProductDetailForm } from '../ProductDetailForm/ProductDetailForm';
import { Quantity } from '../ProductQuantity/ProductQuantity';
import { Price } from '../../../../../UI/Price/Price';
import { WishListMessage } from '../../../../Shared/Content/ProductDetail/WishListMessage/WishListMessage';
import { AddToBrandFavorites } from '../AddToBrandFavorites/AddToBrandFavorites';

export class ProductItemComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      siteFormat: this.props.passedAppFunctions ? this.props.passedAppFunctions.siteFormat : '',
    };
    this.state.quantities = [];
    this.state.quantityEvents = [];
    if (this.props.contentData.attributes) {
      for (var i = 0; i < this.props.contentData.attributes[0].values.length; i++) {
        this.state.quantities.push({ value: 1, errored: false });
        this.state.quantityEvents.push(undefined);
      }
    }

    this.updateAttributeAndAddToBag = this.updateAttributeAndAddToBag.bind(this);
    this.updateAttributeAndAddToWishlist = this.updateAttributeAndAddToWishlist.bind(this);
    this.updateAttributeAndAddToRegistry = this.updateAttributeAndAddToRegistry.bind(this);
    this.updateAttributeAndAddToFavorites = this.updateAttributeAndAddToFavorites.bind(this);
    this.updateQuantities = this.updateQuantities.bind(this);
    this.forceItemQuantity = this.forceItemQuantity.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.contentData.productId &&
      (this.props.contentData.productId != nextProps.contentData.productId ||
        this.props.contentData.salePage != nextProps.contentData.salePage)
    ) {
      this.state.quantities = [];
      this.state.quantityEvents = [];
      for (var i = 0; i < nextProps.contentData.attributes[0].values.length; i++) {
        this.state.quantities.push({ value: 1, errored: false });
        this.state.quantityEvents.push(undefined);
      }
    }
  }
  validateParameters(thisIndex, doNotRender) {
    var formValid = true;
    var thisQuantityEvent = this.state.quantityEvents[thisIndex];
    if (thisQuantityEvent && thisQuantityEvent.target.value == '') {
      if (!doNotRender) this.state.quantities[thisIndex].errored = true;
      formValid = false;
    }
    if (!formValid && !doNotRender) {
      this.setState({}); //to update visuals since we won't be doing any more work this click
      this.props.passedFunctions.formNotValid();
    }
    return formValid;
  }
  updateAttributeAndAddToBag(event) {
    console.log(event);
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      if (thisAttrName !== 'Item') {
        thisAttrName = key;
      }
    });
    this.props.passedFunctions.updateAttributeState(thisAttrName, event.target.getAttribute('data-attritem'));

    this.props.passedFunctions.addToBagClicked();
    var thisIndex = event.target.getAttribute('data-index');
    if (this.validateParameters(thisIndex)) {
      if (this.state.quantityEvents[thisIndex]) {
        this.props.passedFunctions.updateQuantity(this.state.quantityEvents[thisIndex]);
      } else {
        this.props.passedFunctions.updateQuantity(this.fakeQuantityObject());
      }
      this.props.passedFunctions.ajaxAddToBag(event);
    }
  }
  updateAttributeAndAddToWishlist(event) {
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      if (thisAttrName !== 'Item') {
        thisAttrName = key;
      }
    });
    this.props.passedFunctions.addToBagClicked();
    var thisIndex = event.target.getAttribute('data-index');
    if (this.validateParameters(thisIndex)) {
      this.props.passedFunctions.updateAttributeState(thisAttrName, event.target.getAttribute('data-attritem'));
      this.props.passedFunctions.ajaxAddToWishlist(event);
    }
  }
  updateAttributeAndAddToRegistry(event) {
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      if (thisAttrName !== 'Item') {
        thisAttrName = key;
      }
    });
    this.props.passedFunctions.addToBagClicked();
    var thisIndex = event.target.getAttribute('data-index');
    if (this.validateParameters(thisIndex)) {
      if (this.state.quantityEvents[thisIndex]) {
        this.props.passedFunctions.updateQuantity(this.state.quantityEvents[thisIndex]);
      } else {
        this.props.passedFunctions.updateQuantity(this.fakeQuantityObject());
      }
      this.props.passedFunctions.updateAttributeState(thisAttrName, event.target.getAttribute('data-attritem'));
      this.props.passedFunctions.ajaxAddToRegistry(event);
    }
  }
  async updateAttributeAndAddToFavorites(event) {
    this.props.passedFunctions.updateAttribute(event);
    await this.props.passedFunctions.ajaxAddToBrandFavorites(event);
  }
  updateQuantities(event, index) {
    var maximumQuantity = event.target.getAttribute('data-maximum') * 1,
      minimumQuantity = event.target.getAttribute('data-minimum') * 1,
      targetValue = event.target.value || event.target.getAttribute('data-value');
    if (targetValue == null || targetValue == undefined) targetValue = '';
    let isANum = !isNaN(targetValue),
      isANum_space = isANum && targetValue.toString().indexOf(' ') > -1,
      decimalNum = targetValue.toString().indexOf('.') > -1,
      noPeriodsOrSpaces = !(isANum_space || decimalNum);
    if (
      targetValue == '' ||
      (isANum && noPeriodsOrSpaces && targetValue <= maximumQuantity && targetValue >= minimumQuantity)
    ) {
      var newQuantitiesObject = JSON.parse(JSON.stringify(this.state.quantities));
      newQuantitiesObject[index].value = targetValue;
      newQuantitiesObject[index].errored = false;
      if (event.target.getAttribute('data-value')) {
        var fakeModifiedQuantityObject = this.fakeQuantityObject();
        fakeModifiedQuantityObject.target.value = targetValue;
        this.state.quantityEvents[index] = fakeModifiedQuantityObject;
      } else {
        this.state.quantityEvents[index] = {
          target: event.target,
        };
      }
      this.setState({
        quantities: newQuantitiesObject,
      });
    }
  }
  forceItemQuantity(event, index) {
    var newQuantitiesObject = JSON.parse(JSON.stringify(this.state.quantities));
    newQuantitiesObject[index].value = 1;
    newQuantitiesObject[index].errored = false;
    if (event.target.getAttribute('data-value')) {
      var fakeModifiedQuantityObject = this.fakeQuantityObject();
      fakeModifiedQuantityObject.target.value = 1;
      this.state.quantityEvents[index] = fakeModifiedQuantityObject;
    } else {
      this.state.quantityEvents[index] = {
        target: event.target,
      };
    }
    this.setState({
      quantities: newQuantitiesObject,
    });
  }
  fakeQuantityObject() {
    return {
      target: {
        value: '1',
        getAttribute: function (attribute) {
          if (attribute == 'data-minimum') {
            return 1;
          }
          if (attribute == 'data-maximum') {
            return 99;
          }
        },
      },
    };
  }

  thisAttributeSelected(thisAttributeValue) {
    let returnBool = false;
    let thisAttrName = '';
    Object.keys(this.props.currentAttributeState).map((key) => {
      if (thisAttrName !== 'Item') {
        thisAttrName = key;
      }
    });
    if (this.props.currentAttributeState) {
      if (thisAttributeValue === this.props.currentAttributeState[thisAttrName].selectedValue) {
        returnBool = true;
      }
    }
    return returnBool;
  }

  render() {
    if (this.props.contentData.attributes) {
      var thisAttribute = (thisAttribute = this.props.contentData.attributes[0]),
        productItem__img = 'col-sm-3',
        productItem__description = 'col-sm-3',
        productItem__quantity = 'col-sm-3',
        productItem__shopperActions = 'col-sm-3';

      if (this.state.siteFormat == 'mobile') {
        productItem__img = 'col-6';
        productItem__description = 'col-6';
        productItem__quantity = 'col-12';
        productItem__shopperActions = 'col-12';
      }
      console.log(21);
      return (
        <div>
          {thisAttribute.values.map((thisAttributeValue, index) => (
            <div className='col-sm-12 productItem__wrapper' key={index}>
              <ProductDetailForm contentData={this.props.contentData} passedFunctions={this.props.passedFunctions}>
                <div className={`${productItem__img} productItem__img`}>
                  <img
                    src={`//dimg.dillards.com/is/image/DillardsZoom/productItem/${this.props.contentData.productNameForURL}/${thisAttributeValue.image}.jpg`}
                    alt={
                      this.props.contentData.brandNameForTitle +
                      ' ' +
                      this.props.contentData.productName +
                      '-' +
                      thisAttributeValue.name.split('#double;').join('"')
                    }
                  />
                </div>
                <div className={`${productItem__description} productItem__description`}>
                  <div className='productItem__title'>
                    <span>{thisAttributeValue.name.split('#double;').join('"')}</span>
                  </div>
                  <div>
                    <Price price={thisAttributeValue.itemPrice} />
                  </div>
                </div>
                <div className={`${productItem__quantity}`}>
                  <Quantity
                    className={this.state.quantities[index].errored ? 'errored' : ''}
                    updateQuantity={(event) => {
                      this.updateQuantities(event, index);
                    }}
                    quantity={this.state.quantities[index].value}
                    quantityErrored={this.state.quantities[index].errored}
                    contentData={this.props.contentData}
                    passedAppFunctions={this.props.passedAppFunctions}
                    isProductItem='true'
                    forceItemQuantity={(event) => {
                      this.forceItemQuantity(event, index);
                    }}
                  />
                </div>
                <div className={`${productItem__shopperActions}`}>
                  <button
                    role='button'
                    type='button'
                    id='add-to-bag'
                    className='btn btn-primary btn-block'
                    data-val={thisAttributeValue.name.split('#double;').join('"')}
                    data-attrval={thisAttributeValue.value}
                    data-attritem={thisAttributeValue.name.split('#double;').join('"')}
                    data-attrid={thisAttribute.attrId}
                    data-index={index}
                    onClick={this.updateAttributeAndAddToBag}
                  >
                    Add To Bag
                  </button>
                  {this.thisAttributeSelected(thisAttributeValue.name.split('#double;').join('"')) ? (
                    <WishListMessage
                      passedFunctions={this.props.passedFunctions}
                      passedAppFunctions={this.props.passedAppFunctions}
                    />
                  ) : (
                    ''
                  )}
                  {typeof window == 'undefined' || window.DILLARDS.country == 'US' ? (
                    <button
                      className='btn btn-tertiary btn-block'
                      role='button'
                      type='button'
                      id='add-to-wishlist'
                      data-attrval={thisAttributeValue.value}
                      data-attrid={thisAttribute.attrId}
                      data-index={index}
                      data-attritem={thisAttributeValue.name.split('#double;').join('"')}
                      onClick={this.updateAttributeAndAddToWishlist}
                      // onClick={this.props.passedFunctions.ajaxAddToWishlist}
                    >
                      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.58 12.44'>
                        <title>heart</title>
                        <g data-name='Layer 2'>
                          <g data-name='Layer 1'>
                            <path
                              className='cls-1'
                              d='M7.79,12.44a.54.54,0,0,1-.32-.11L1.66,7.46l0,0A4.78,4.78,0,0,1,0,4.14,4.15,4.15,0,0,1,4.14,0,4.13,4.13,0,0,1,7.82,2.14,4.19,4.19,0,1,1,14.3,7.33l-6.19,5A.5.5,0,0,1,7.79,12.44ZM2.32,6.71,7.8,11.29l5.84-4.71a3.15,3.15,0,0,0-2.21-5.4,3,3,0,0,0-3.08,2.4.51.51,0,0,1-.07.17A.64.64,0,0,1,7.83,4a.5.5,0,0,1-.44-.18,1.3,1.3,0,0,1-.14-.29A3,3,0,0,0,4.14,1,3.15,3.15,0,0,0,1,4.14,3.66,3.66,0,0,0,2.32,6.71Z'
                            />
                          </g>
                        </g>
                      </svg>
                      Add To Wish List
                    </button>
                  ) : (
                    ''
                  )}

                  {typeof window == 'undefined' || window.DILLARDS.country == 'US' ? (
                    <button
                      className='btn btn-tertiary btn-block'
                      role='button'
                      type='button'
                      id='add-to-registry'
                      data-attrval={thisAttributeValue.value}
                      data-attrid={thisAttribute.attrId}
                      data-index={index}
                      data-attritem={thisAttributeValue.name.split('#double;').join('"')}
                      onClick={this.updateAttributeAndAddToRegistry}
                      // onClick={this.props.passedFunctions.ajaxAddToRegistry}
                    >
                      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50.42 49.84'>
                        <title>gift</title>
                        <g data-name='Layer 2'>
                          <g data-name='Layer 1'>
                            <path d='M48,9.79H39.64a5.33,5.33,0,0,0-1-9.43,5.3,5.3,0,0,0-4.09.1c-2.16,1-8,7.3-9.37,8.82C23.8,7.76,18,1.42,15.81.46a5.33,5.33,0,0,0-5.1,9.33H2.45A2.45,2.45,0,0,0,0,12.24v4.39a2.45,2.45,0,0,0,2.45,2.45H3a3.46,3.46,0,0,0-.53,1.84V46.35a3.5,3.5,0,0,0,3.49,3.49H44.41a3.5,3.5,0,0,0,3.49-3.49V20.92a3.46,3.46,0,0,0-.53-1.84H48a2.45,2.45,0,0,0,2.45-2.45V12.24A2.45,2.45,0,0,0,48,9.79ZM35.36,2.3A3.32,3.32,0,0,1,38,8.39c-1.2.53-6.12.76-10.05.81C30.68,6.32,34.16,2.83,35.36,2.3ZM10.61,4A3.33,3.33,0,0,1,15,2.3c1.2.53,4.68,4,7.36,6.89-3.93,0-8.85-.28-10.05-.81h0A3.33,3.33,0,0,1,10.61,4ZM2,16.63V12.24a.43.43,0,0,1,.43-.43H24.2v5.26H2.45A.43.43,0,0,1,2,16.63ZM4.47,46.35V20.92a1.48,1.48,0,0,1,1.48-1.48H24.2V47.82H5.94A1.48,1.48,0,0,1,4.47,46.35Zm41.42,0a1.48,1.48,0,0,1-1.48,1.48H26.22V19.44H44.41a1.48,1.48,0,0,1,1.48,1.48Zm2.52-29.71a.43.43,0,0,1-.43.43H26.22V11.81H48a.43.43,0,0,1,.43.43Z' />
                          </g>
                        </g>
                      </svg>
                      Add To Registry
                    </button>
                  ) : (
                    ''
                  )}
                  <AddToBrandFavorites
                    passedAppFunctions={this.props.passedAppFunctions}
                    contentData={this.props.contentData}
                    passedFunctions={this.props.passedFunctions}
                    passedOnClick={this.updateAttributeAndAddToFavorites}
                    passedDataIds={{
                      'data-attrval': thisAttributeValue.value,
                      'data-attrid': thisAttribute.attrId,
                      'data-index': index,
                    }}
                  />
                </div>
              </ProductDetailForm>
            </div>
          ))}
        </div>
      );
    } else {
      return '';
    }
  }
}

export default ProductItemComponent;
